import { jsonldPage } from './JsonldStore';

export const updateJsonldPage = (value) => jsonldPage.update((oldValue) => value);
